import script from "./PostListView.vue?vue&type=script&setup=true&lang=ts"
export * from "./PostListView.vue?vue&type=script&setup=true&lang=ts"

import "./PostListView.vue?vue&type=style&index=0&id=1e16ab24&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e16ab24"]])

export default __exports__